import * as React from 'react';
import { ComponentsState, SwitchErrorInfo, useGlobalState } from 'piral-core';
import { Notifications } from 'piral-notifications';
import { SnowfallContainer, isChristmasTime } from '../../snowfall-api';
import { FirefliesContainer } from '../../fireflies-api';
import { Loading } from '../Loading/Loading';
import { Sidebar } from '../Sidebar/Sidebar';
import { Link, useLocation } from 'react-router-dom';
import { Toast } from '../Toast/Toast';
import { LoginNotification } from '../LoginNotification/LoginNotification';
import { Header } from '../Header/Header';
import { useTilesStore } from '../../siplet-api/tiles.store';
import { Spotlight } from '../Spotlight/Spotlight';
import { SortableTileContainer } from '../Dashboard/SortableTileContainer';

import './layout.css';
import { ProjectIcon } from '../../snowfall-api/components/ProjectIcon/ProjectIcon';
import { SnowAccumulation } from '../../snowfall-api/components/SnowAccumulation/SnowAccumulation';
import Jumpscare from '../Jumpscare/Jumpscare';
import { QuickNotes } from '../QuickNotes/QuickNotes';
import { ConfirmDialog } from '../ConfirmDialog/ConfirmDialog';
import { ReleaseNotesButton } from '../ReleaseNotesButton/ReleaseNotesButton';
import { CalendarDialog } from '../CalendarDialog/CalendarDialog';

export const components: Partial<ComponentsState> = {
  ErrorInfo: props => (
    <div className="neo-info-card">
      <SwitchErrorInfo {...props} />
    </div>
  ),
  Layout: ({ children }) => (
    <>
      <SnowfallContainer />
      <SnowAccumulation />
      <FirefliesContainer />
      <Header />
      <Sidebar />

      <div className="neo-app-content">
        <div id="app-content" className="neo-app-content-children">
          <LoginNotification />
          {children}
        </div>
      </div>
      <Notifications />
      <Jumpscare />
      <Spotlight />
      <QuickNotes />
      <ConfirmDialog />
      <ReleaseNotesButton />
      <CalendarDialog />
    </>
  ),
  LoadingIndicator: Loading,
  NotificationsHost: ({ children }) => <div className="neo-notification-host app-toast-spacing">{children}</div>,
  NotificationsToast: Toast,
  DashboardContainer: ({ children }) => {
    const { favorites } = useTilesStore();
    const tiles = React.Children.toArray(children);

    const grouped = tiles.reduce(
      (acc, tile: any) => {
        const tileKey = tile.key?.split('//')[1] || tile.key;
        const group = favorites.includes(tileKey) ? 'favorite' : 'standard';
        acc[group].push(tile);
        return acc;
      },
      { favorite: [] as React.ReactNode[], standard: [] as React.ReactNode[] },
    );

    return (
      <>
        {grouped.favorite.length > 0 && (
          <SortableTileContainer group="favorite" className="neo-dashboard neo-dashboard-top">
            {grouped.favorite}
          </SortableTileContainer>
        )}
        <SortableTileContainer group="standard" className="neo-dashboard">
          {grouped.standard}
        </SortableTileContainer>
      </>
    );
  },
  DashboardTile: ({ children }) => {
    const snowActive = isChristmasTime();
    return <div className={`neo-dashboard-tile${snowActive ? ' snow-active' : ''}`}>{children}</div>;
  },
  BreadcrumbsContainer: ({ children }) => (
    <ol className="neo-breadcrumbs" aria-label="Breadcrumb">
      <ProjectIcon />
      {children}
    </ol>
  ),
  BreadcrumbItem: ({ children, current, path }) => {
    if (current) {
      return (
        <li className="neo-breadcrumbs-item" aria-current="page">
          {children}
        </li>
      );
    } else {
      return (
        <>
          <Link className="neo-breadcrumbs-item-link" to={path}>
            {children}
          </Link>
          <svg className="neo-breadcrumbs-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </>
      );
    }
  },
};
